import VueCookie from 'vue-cookie';

export default {
    data() {
        return {
        }
    },
    mounted() {
        this.initTimePlugin();
    },
    methods: {
        // 包年包月时长选择
        initTimePlugin() {
            $('.time-choose li').click(function () {
                if (VueCookie.get(this.GLOBALCOOKIE) === 'cn') {
                    $('.time-choose li').removeClass('cur').removeClass('sel');
                    $(this).addClass('cur');
                } else if (VueCookie.get(this.GLOBALCOOKIE) === 'en') {
                    $('.time-choose li').removeClass('curEn').removeClass('sel');
                    $(this).addClass('curEn');
                }
            });
            $(this).prevAll().addClass('sel');
        },
    }
}




// WEBPACK FOOTER //
// ./src/mixins/buyTime.js